<template>
    <div class="import-csv-container">
        <Tooltip text="Import CSV file" class="import-csv-tooltip">
            <button type="button" class="primary">
                <label>
                    <IconBase :iconName="icon"
                              :iconColor="consts.COLORS.WHITE"
                              height="16px"
                              width="16px"
                              class="import-icon"
                              display="flex"
                    ></IconBase>
                    <input :name="name"
                           :disabled="!enabled"
                           :accept="fileTypes"
                           :value="file"
                           @change="fileChanged($event.target.files)"
                           type="file"
                           class="input-file">
                </label>
            </button>
        </Tooltip>
    </div>
</template>

<script>
import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';
import VuePapaParse from 'vue-papa-parse';
import Vue from 'vue';

Vue.use(VuePapaParse);

export default {
    name: 'ImportCSV',
    components: { Tooltip, IconBase },
    props: {
        icon: {
            type: String,
            default: 'uploadIcon'
        },
        fileTypes: {
            type: [String, Array],
            default: '.csv'
        },
        enabled: Boolean,
        name: String
    },
    data() {
        return {
            consts,
            parsedFile: null,
            uploading: false,
            file: null
        };
    },
    methods: {
        fileChanged(files) {
            this.uploading = true;
            this.file = this.$papa.parse(files[0], {
                dynamicTyping: true,
                header: true,
                skipEmptyLines: true,
                worker: true,
                complete: (file) => {
                    this.uploading = false;
                    if (file.errors.length > 0) {
                        this.$emit('fileUploadedError');
                        return;
                    }
                    this.parsedFile = {
                        data: file.data,
                        fields: file.meta.fields
                    };
                    this.$emit('fileUploaded', this.parsedFile);
                    this.file = null;
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
@import "~styles/styleGuide.scss";
@import "~styles/buttons";

button {
    min-width: initial;
    width: 32px;
    padding: 0;
    border: none;
    outline: none;
}

.import-icon {
    display: flex;
    height: 32px;
    width: 32px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.input-file {
    display: none;
}

.import-csv-container {
    display: flex;
}
</style>
